module.exports = __webpack_public_path__ + "static/media/GR.86f08502.png";